import { render, staticRenderFns } from "./newSix.vue?vue&type=template&id=76e09498&scoped=true&"
import script from "./newSix.vue?vue&type=script&lang=js&"
export * from "./newSix.vue?vue&type=script&lang=js&"
import style0 from "./newSix.vue?vue&type=style&index=0&id=76e09498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e09498",
  null
  
)

export default component.exports